module.exports = __webpack_public_path__ + "media/images/photos/11-eab71b65aab2d763863d65099257e219.jpg";